import { client } from "../../../api/client";

export const createQuoteTemplateTag = async (body) => {
  if (process.env.REACT_APP_USELOCALDATA === "false") {
    try {
        return await client.post(process.env.REACT_APP_GATEWAY_URI,"templatesapi/quotetemplatetag", body);
    } catch (error) {
        console.error("Error creating quote template tag:", error);
        return [];
    }
  }
};

export const deleteQuoteTemplateTags = async (quoteTemplateId) => {
  if (process.env.REACT_APP_USELOCALDATA === "false") {
    try {
        return await client.delete(process.env.REACT_APP_GATEWAY_URI,`templatesapi/quotetemplatetag/deletebyquotetemplateid/${quoteTemplateId}`);
    } catch (error) {
        console.error("Error deleting quote template tags:", error);
        return [];
    }
  }
};